
import { defineComponent, reactive, toRefs } from "vue";
import ProjectExperience from "./../updateCv/projectExperience.vue";
import { Delete, CirclePlus, EditPen } from "@element-plus/icons-vue";
import { recruitService } from "@/api";
import utils from "@/utils/util";
import { ElMessage } from "element-plus/lib/components";
export default defineComponent({
  props: {
    detail: Object,
  },
  components: {
    ProjectExperience,
  },
  setup(props) {
    const state = reactive<{
      autoSize: any;
      detail: any;
      diaLogTitle: string;
      dialogVisible: boolean;
      projectExpList: any;
    }>({
      autoSize: { minRows: 4, maxRows: 6 },
      detail: props.detail,
      dialogVisible: false,
      projectExpList: [],
      diaLogTitle: "编辑项目经历",
    });
    function edit(name: string, obj?: any) {
      if (obj) {
        const daterange = [
          utils.dateFm(obj.startDate, "YYYY-MM-DD"),
          utils.dateFm(obj.endDate, "YYYY-MM-DD"),
        ];
        obj["guid"] = utils.guid();
        const target = JSON.parse(
          JSON.stringify(Object.assign(obj, { daterange: daterange }))
        );
        state.projectExpList = [target];
      } else {
        state.projectExpList = [];
      }
      state.diaLogTitle = name;
      state.dialogVisible = true;
    }
    function deleteInfo(obj: any, index: number) {
      recruitService.user
        .deleteProject(obj)
        .then(() => {
          ElMessage.success("删除成功！");
          state.detail.projectExpList.splice(index, 1);
        })
        .catch((val) => {
          if (val.isHttpStatus) {
            console.log(val.statusText);
          } else {
            ElMessage.error(val.message || "错误");
          }
        });
    }
    function closeDialog() {
      state.dialogVisible = false;
    }
    function save(body: any) {
      state.detail = Object.assign(state.detail, body);
      closeDialog();
    }
    return {
      ...toRefs(state),
      CirclePlus,
      Delete,
      EditPen,
      edit,
      deleteInfo,
      save,
      closeDialog,
    };
  },
});
